// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_SUtvD {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid rgba(206, 214, 222, 1);
  border-radius: 8px;
  background-color: white;
  flex-grow: 1;
  width: 100%;
}

.header_xOcF2 {
  display : flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  border-radius: 8px 8px 0px 0px;
  height : 48px;
  background-color: rgba(249, 250, 251, 1);
  border-bottom :  1px solid rgba(206, 214, 222, 1);
  padding : 11px 0px 11px 0px;
  width : 100%;
}

.hr-divider_LXMfv {
  border: 1px 0;
  border-top: 1px solid rgba(206, 214, 222, 1);
  margin: 20px -16px;
}

.body_xOA8v {
  width: 100%;
  padding: 16px;
}

.stageIndicator_JICzY {
  display : flex;
  justify-content: center;
  align-items: center;
  min-height: 28px;
  padding: 4px 8px 4px 8px;
  border-radius: 4px;
  border: 1px 1px;
  opacity: 0px;
  /* //styleName: Body/Normal - Bold; */
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-bottom : 16px;
  border-width: 1px;
  border-style: solid;
}

.prep_e9MBo {
  border-color: var( --color-stagePrepBdr );
  background-color: var( --color-stagePrepBg );
}

.layup_fsw8n {
  border-color: var( --color-stageLayupBdr );
  background-color: var( --color-stageLayupBg );
}

.infusion_kbvEb {
  border-color: var( --color-stageInfusionBdr );
  background-color: var( --color-stageInfusionBg );
}

.inspection_zLWxW {
  border-color: var( --color-stageInspectionBdr );
  background-color: var( --color-stageInspectionBg );
}

.webAndClose_wmzur {
  border-color: var( --color-stageWebBdr );
  background-color: var( --color-stageWebBg );
}

.inactive_vQcUh {
  border-color: var( --color-stageInactiveBdr );
  background-color: var( --color-stageInactiveBg );
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineLiveStatus/MoldHalfCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,wCAAwC;EACxC,iDAAiD;EACjD,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  border: 1px solid rgba(206, 214, 222, 1);\n  border-radius: 8px;\n  background-color: white;\n  flex-grow: 1;\n  width: 100%;\n}\n\n.header {\n  display : flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  border-radius: 8px 8px 0px 0px;\n  height : 48px;\n  background-color: rgba(249, 250, 251, 1);\n  border-bottom :  1px solid rgba(206, 214, 222, 1);\n  padding : 11px 0px 11px 0px;\n  width : 100%;\n}\n\n.hr-divider {\n  border: 1px 0;\n  border-top: 1px solid rgba(206, 214, 222, 1);\n  margin: 20px -16px;\n}\n\n.body {\n  width: 100%;\n  padding: 16px;\n}\n\n.stageIndicator {\n  display : flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 28px;\n  padding: 4px 8px 4px 8px;\n  border-radius: 4px;\n  border: 1px 1px;\n  opacity: 0px;\n  /* //styleName: Body/Normal - Bold; */\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom : 16px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.prep {\n  border-color: var( --color-stagePrepBdr );\n  background-color: var( --color-stagePrepBg );\n}\n\n.layup {\n  border-color: var( --color-stageLayupBdr );\n  background-color: var( --color-stageLayupBg );\n}\n\n.infusion {\n  border-color: var( --color-stageInfusionBdr );\n  background-color: var( --color-stageInfusionBg );\n}\n\n.inspection {\n  border-color: var( --color-stageInspectionBdr );\n  background-color: var( --color-stageInspectionBg );\n}\n\n.webAndClose {\n  border-color: var( --color-stageWebBdr );\n  background-color: var( --color-stageWebBg );\n}\n\n.inactive {\n  border-color: var( --color-stageInactiveBdr );\n  background-color: var( --color-stageInactiveBg );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_SUtvD`,
	"header": `header_xOcF2`,
	"hr-divider": `hr-divider_LXMfv`,
	"body": `body_xOA8v`,
	"stageIndicator": `stageIndicator_JICzY`,
	"prep": `prep_e9MBo`,
	"layup": `layup_fsw8n`,
	"infusion": `infusion_kbvEb`,
	"inspection": `inspection_zLWxW`,
	"webAndClose": `webAndClose_wmzur`,
	"inactive": `inactive_vQcUh`
};
export default ___CSS_LOADER_EXPORT___;
